import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as groupCategoryActions from './../../../../../actions/groupCategoryAction';
import GroupCategoryDetail from './GroupCategoryDetail';

const mapStateToProps = state => {
    return {
        groupCategoryState: state.groupCategoryReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getAllGroupCategories: (filters) => dispatch(groupCategoryActions.getAllGroupCategories(filters)),
        getGroupCategoryDetail: (id) => dispatch(groupCategoryActions.getGroupCategoryDetail(id)),
        setGroupCategoryDetail: (groupCategory) => dispatch(groupCategoryActions.setGroupCategoryDetail(groupCategory)),
        createGroupCategory: (groupCategory) => dispatch(groupCategoryActions.createGroupCategory(groupCategory)),
        updateGroupCategory: (groupCategory) => dispatch(groupCategoryActions.updateGroupCategory(groupCategory)),
        // getGroupCategoryTranslate: (id, language) => dispatch(groupCategoryActions.getGroupCategoryTranslate(id, language)),
        // setGroupCategoryTranslate: (groupCategory, language) => dispatch(groupCategoryActions.setGroupCategoryTranslate(groupCategory, language)),
        createGroupCategoryTranslate: (groupCategory, language) => dispatch(groupCategoryActions.createGroupCategoryTranslate(groupCategory, language)),
        updateGroupCategoryTranslate: (groupCategory, language) => dispatch(groupCategoryActions.updateGroupCategoryTranslate(groupCategory, language)),
        deleteGroupCategoryTranslate: (groupCategory, refreshParams) => dispatch(groupCategoryActions.deleteGroupCategoryTranslate(groupCategory, refreshParams)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(GroupCategoryDetail));
